import { render } from "./ListeMatiere.vue?vue&type=template&id=4e3a1b16&ts=true"
import script from "./ListeMatiere.vue?vue&type=script&lang=ts"
export * from "./ListeMatiere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__